var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "store-details" }, [
    _c("div", { staticClass: "step step-sp" }, [
      _c("div", { staticClass: "stepBox" }, [
        _c("div", { staticClass: "step-container step-container-sp" }, [
          _c("span", { staticClass: "store-name store-name-sp" }, [
            _vm._v(
              _vm._s(_vm.$t("retailStoresInfo.title.storeName")) +
                ": " +
                _vm._s(_vm.form.rtlFullName)
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              on: {
                click: function ($event) {
                  return _vm.jump("baseInfo")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("retailStoresInfo.form.baseInfo.title")))]
          ),
          _vm._v(" "),
          _c("em", { staticClass: "el-icon-d-arrow-right" }),
          _vm._v(" "),
          _c(
            "div",
            {
              on: {
                click: function ($event) {
                  return _vm.jump("moreInfo")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("retailStoresInfo.form.moreInfo.title")))]
          ),
          _vm._v(" "),
          _c("em", { staticClass: "el-icon-d-arrow-right" }),
          _vm._v(" "),
          _c(
            "div",
            {
              on: {
                click: function ($event) {
                  return _vm.jump("storeArchSit")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("retailStoresInfo.form.storeArchSit.title")))]
          ),
          _vm._v(" "),
          _c("em", { staticClass: "el-icon-d-arrow-right" }),
          _vm._v(" "),
          _c(
            "div",
            {
              on: {
                click: function ($event) {
                  return _vm.jump("storeInfoPic")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("retailStoresInfo.form.storeInfoPic.title")))]
          ),
          _vm._v(" "),
          _c("em", { staticClass: "el-icon-d-arrow-right" }),
          _vm._v(" "),
          _c(
            "div",
            {
              on: {
                click: function ($event) {
                  return _vm.jump("mainServicesInStore")
                },
              },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$t("retailStoresInfo.form.mainServicesInStore.title")
                )
              ),
            ]
          ),
          _vm._v(" "),
          _c("em", { staticClass: "el-icon-d-arrow-right" }),
          _vm._v(" "),
          _c(
            "div",
            {
              on: {
                click: function ($event) {
                  return _vm.jump("storeFacEqu")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("retailStoresInfo.form.storeFacEqu.title")))]
          ),
          _vm._v(" "),
          _c("em", { staticClass: "el-icon-d-arrow-right" }),
          _vm._v(" "),
          _c(
            "div",
            {
              on: {
                click: function ($event) {
                  return _vm.jump("otherRecord")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("retailStoresInfo.form.otherRecord.title")))]
          ),
          _vm._v(" "),
          _c("em", { staticClass: "el-icon-d-arrow-right" }),
          _vm._v(" "),
          _c(
            "div",
            {
              on: {
                click: function ($event) {
                  return _vm.jump("otherBrandSales")
                },
              },
            },
            [
              _vm._v(
                _vm._s(_vm.$t("retailStoresInfo.form.otherBrandSales.title"))
              ),
            ]
          ),
          _vm._v(" "),
          _c("em", { staticClass: "el-icon-d-arrow-right" }),
          _vm._v(" "),
          _c(
            "div",
            {
              on: {
                click: function ($event) {
                  return _vm.jump("ttpSignAesc")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("retailStoresInfo.form.ttpSignAesc.title")))]
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "app-container" },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "FPermission",
                rawName: "v-FPermission",
                value: { pageName: _vm.pageName, list: ["ADD_EDIT"] },
                expression: "{pageName, list: ['ADD_EDIT']}",
              },
            ],
            staticClass: "header-btn",
          },
          [
            _vm.type === "view"
              ? _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.edit("view")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.edit")))]
                )
              : _vm.type === "edit"
              ? _c(
                  "el-button",
                  {
                    attrs: { size: "mini" },
                    on: {
                      click: function ($event) {
                        return _vm.edit("edit")
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "action-container" },
          [
            _c(
              "el-form",
              {
                ref: "dataForm",
                attrs: {
                  size: "small",
                  rules: _vm.rules,
                  model: _vm.form,
                  inline: "",
                  "label-position": "top",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "container-item", attrs: { id: "baseInfo" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "container-item-title",
                        on: {
                          click: function ($event) {
                            _vm.baseInfoCollapse = !_vm.baseInfoCollapse
                          },
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("retailStoresInfo.form.baseInfo.title")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("em", {
                          staticClass: "el-submenu__icon-arrow",
                          class: _vm.baseInfoCollapse
                            ? "el-icon-arrow-down2"
                            : "el-icon-arrow-down",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("base-info", {
                      attrs: {
                        rules: _vm.rules,
                        show: _vm.baseInfoCollapse,
                        "lookup-list": _vm.lookupList,
                        form: _vm.form,
                        type: _vm.type,
                        "is-qzkh": _vm.isQzkh,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "container-item", attrs: { id: "moreInfo" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "container-item-title",
                        on: {
                          click: function ($event) {
                            _vm.moreInfoCollapse = !_vm.moreInfoCollapse
                          },
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("retailStoresInfo.form.moreInfo.title")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("em", {
                          staticClass: "el-submenu__icon-arrow",
                          class: _vm.moreInfoCollapse
                            ? "el-icon-arrow-down2"
                            : "el-icon-arrow-down",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("more-info", {
                      attrs: {
                        type: _vm.type,
                        show: _vm.moreInfoCollapse,
                        "lookup-list": _vm.lookupList,
                        form: _vm.form,
                        rules: _vm.rules,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "container-item",
                    attrs: { id: "storeArchSit" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "container-item-title",
                        on: {
                          click: function ($event) {
                            _vm.storeArchSitCollapse = !_vm.storeArchSitCollapse
                          },
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("retailStoresInfo.form.storeArchSit.title")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("em", {
                          staticClass: "el-submenu__icon-arrow",
                          class: _vm.storeArchSitCollapse
                            ? "el-icon-arrow-down2"
                            : "el-icon-arrow-down",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("store-arch-sit", {
                      attrs: {
                        type: _vm.type,
                        show: _vm.storeArchSitCollapse,
                        "lookup-list": _vm.lookupList,
                        form: _vm.form,
                        rules: _vm.rules,
                        "is-bailian-flag": _vm.isBailianFlag,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "container-item",
                    attrs: { id: "storeInfoPic" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "container-item-title",
                        on: {
                          click: function ($event) {
                            _vm.storeInfoPicCollapse = !_vm.storeInfoPicCollapse
                          },
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("retailStoresInfo.form.storeInfoPic.title")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("em", {
                          staticClass: "el-submenu__icon-arrow",
                          class: _vm.storeInfoPicCollapse
                            ? "el-icon-arrow-down2"
                            : "el-icon-arrow-down",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("store-info-pic", {
                      attrs: {
                        type: _vm.type,
                        show: _vm.storeInfoPicCollapse,
                        "lookup-list": _vm.lookupList,
                        form: _vm.form,
                        rules: _vm.rules,
                        "is-bailian-flag": _vm.isBailianFlag,
                      },
                      on: { "validte-upload": _vm.validateUpload },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "container-item",
                    attrs: { id: "mainServicesInStore" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "container-item-title",
                        on: {
                          click: function ($event) {
                            _vm.mainServicesInStoreCollapse =
                              !_vm.mainServicesInStoreCollapse
                          },
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "retailStoresInfo.form.mainServicesInStore.title"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("em", {
                          staticClass: "el-submenu__icon-arrow",
                          class: _vm.mainServicesInStoreCollapse
                            ? "el-icon-arrow-down2"
                            : "el-icon-arrow-down",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("main-services-in-store", {
                      attrs: {
                        type: _vm.type,
                        show: _vm.mainServicesInStoreCollapse,
                        "lookup-list": _vm.lookupList,
                        form: _vm.form,
                        rules: _vm.rules,
                        "is-bailian-flag": _vm.isBailianFlag,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "container-item",
                    attrs: { id: "storeFacEqu" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "container-item-title",
                        on: {
                          click: function ($event) {
                            _vm.storeFacEquCollapse = !_vm.storeFacEquCollapse
                          },
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("retailStoresInfo.form.storeFacEqu.title")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("em", {
                          staticClass: "el-submenu__icon-arrow",
                          class: _vm.storeFacEquCollapse
                            ? "el-icon-arrow-down2"
                            : "el-icon-arrow-down",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("store-fac-equ", {
                      attrs: {
                        type: _vm.type,
                        show: _vm.storeFacEquCollapse,
                        "lookup-list": _vm.lookupList,
                        form: _vm.form,
                        rules: _vm.rules,
                        "is-bailian-flag": _vm.isBailianFlag,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "container-item",
                    attrs: { id: "otherRecord" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "container-item-title",
                        on: {
                          click: function ($event) {
                            _vm.otherInfoCollapse = !_vm.otherInfoCollapse
                          },
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("retailStoresInfo.form.otherRecord.title")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("em", {
                          staticClass: "el-submenu__icon-arrow",
                          class: _vm.otherInfoCollapse
                            ? "el-icon-arrow-down2"
                            : "el-icon-arrow-down",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "other-info" },
                      [
                        _c("other-info", {
                          attrs: {
                            form: _vm.form,
                            show: _vm.otherInfoCollapse,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "container-item",
                    attrs: { id: "otherBrandSales" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "container-item-title",
                        on: {
                          click: function ($event) {
                            _vm.otherBrandSalesCollapse =
                              !_vm.otherBrandSalesCollapse
                          },
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "retailStoresInfo.form.otherBrandSales.title"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("em", {
                          staticClass: "el-submenu__icon-arrow",
                          class: _vm.otherBrandSalesCollapse
                            ? "el-icon-arrow-down2"
                            : "el-icon-arrow-down",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("el-collapse-transition", [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.otherBrandSalesCollapse,
                              expression: "otherBrandSalesCollapse",
                            },
                          ],
                        },
                        [
                          _c("other-sales", {
                            attrs: {
                              "lookup-list": _vm.lookupList,
                              type: _vm.type,
                              form: _vm.form,
                              list: _vm.form.tireSalesInfos,
                              "is-bailian-flag": _vm.isBailianFlag,
                              "has-error-table": _vm.hasErrorTable,
                              rules: _vm.rules,
                            },
                            on: { "valid-table": _vm.validTableUnEmpty },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "tyreEighteenGreater" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "tyreEighteenGreater-title rowLabel",
                              },
                              [
                                _vm.isBailianFlag
                                  ? _c(
                                      "span",
                                      { staticClass: "require-icon" },
                                      [_vm._v("*")]
                                    )
                                  : _vm._e(),
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.$t(
                                        "retailStoresInfo.form.otherBrandSales.tyreEighteenGreater"
                                      )
                                    ) +
                                    "\n                "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "form-item-title u-iptItem",
                                    attrs: {
                                      prop: "tyreEighteenGreater",
                                      rules:
                                        _vm.isBailianFlag && _vm.type === "edit"
                                          ? _vm.rules.tyreEighteenGreaterEmpty
                                          : null,
                                    },
                                  },
                                  [
                                    _c(
                                      "FormInputNumber",
                                      {
                                        staticClass:
                                          "tyreEighteenGreater-input",
                                        attrs: {
                                          val: _vm.form.tyreEighteenGreater,
                                          size: "mini",
                                          max: 100,
                                          step: 0.01,
                                          mode: _vm.type,
                                        },
                                        on: {
                                          "update:val": function (v) {
                                            return _vm.updateFormValue(
                                              v,
                                              "tyreEighteenGreater",
                                              _vm.form
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            attrs: { slot: "append" },
                                            slot: "append",
                                          },
                                          [_vm._v("%")]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "tsTime" }, [
                            _c("div", { staticClass: "rowLabel" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "retailStoresInfo.form.otherBrandSales.updateTime"
                                  )
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(_vm._s(_vm.form.tireSalesLastUpdateTime)),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "container-item",
                    attrs: { id: "ttpSignAesc" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "container-item-title",
                        on: {
                          click: function ($event) {
                            _vm.ttpSignAescCollapse = !_vm.ttpSignAescCollapse
                          },
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("retailStoresInfo.form.ttpSignAesc.title")
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("em", {
                          staticClass: "el-submenu__icon-arrow",
                          class: _vm.ttpSignAescCollapse
                            ? "el-icon-arrow-down2"
                            : "el-icon-arrow-down",
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("el-collapse-transition", [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.ttpSignAescCollapse,
                              expression: "ttpSignAescCollapse",
                            },
                          ],
                        },
                        [
                          _c("ttp-sign-aesc", {
                            attrs: { data: _vm.form.tppVo },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "container-item" }, [
                  _c(
                    "div",
                    { staticClass: "container-item-title" },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("retailStoresInfo.form.model.salesKPI"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini" },
                          on: { click: _vm.salesKPIClick },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.checkDetail")))]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "container-item" }, [
                  _c(
                    "div",
                    { staticClass: "container-item-title" },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("retailStoresInfo.form.model.trainRecord")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini" },
                          on: { click: _vm.trainRecordClick },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.checkDetail")))]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "container-item" }, [
                  _c(
                    "div",
                    { staticClass: "container-item-title" },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("retailStoresInfo.form.model.visitStoRecord")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini" },
                          on: { click: _vm.visitStoRecordClick },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.checkDetail")))]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "container-item" }, [
                  _c(
                    "div",
                    { staticClass: "container-item-title" },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("retailStoresInfo.form.product.common.title")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini" },
                          on: { click: _vm.productClick },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.checkDetail")))]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "footer-btn" },
          [
            _c(
              "el-button",
              {
                staticClass: "back-list-btn",
                attrs: { size: "mini" },
                on: { click: _vm.backList },
              },
              [_vm._v(_vm._s(_vm.$t("retailStoresInfo.common.back")))]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { disabled: _vm.type !== "edit", type: "primary" },
                on: { click: _vm.saveItem },
              },
              [_vm._v(_vm._s(_vm.$t("common.save")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "Model",
          {
            attrs: {
              "is-show": _vm.isShowSalesKPI,
              "dialog-status":
                _vm.$t("retailStoresInfo.form.model.salesKPI") +
                "__" +
                _vm.form.rtlFullName,
              "show-close": _vm.isShowSalesKPI,
              "is-only-confirm": true,
              "close-on-click-modal": _vm.isShowSalesKPI,
              width: "80%",
              "auto-height": "",
            },
            on: {
              "update:isShow": function ($event) {
                _vm.isShowSalesKPI = $event
              },
              "update:is-show": function ($event) {
                _vm.isShowSalesKPI = $event
              },
            },
          },
          [
            _c("SalesKPIRecord", {
              ref: "salesKPIRecord",
              attrs: {
                storecode: _vm.form.rtlSapId,
                storeid: _vm.form.retailorStoreInfoPk,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "Model",
          {
            attrs: {
              "is-show": _vm.isShowProductInfo,
              "dialog-status":
                _vm.$t("retailStoresInfo.form.product.common.title") +
                "__" +
                _vm.form.rtlFullName,
              "show-close": _vm.isShowProductInfo,
              "close-on-click-modal": _vm.isShowProductInfo,
              "is-hide-footer": !_vm.isShowProductInfoHideFooter,
              width: "1200px",
              "auto-height": "",
            },
            on: {
              "update:isShow": function ($event) {
                _vm.isShowProductInfo = $event
              },
              "update:is-show": function ($event) {
                _vm.isShowProductInfo = $event
              },
            },
          },
          [
            _c("product", {
              ref: "product",
              attrs: { visible: _vm.isShowProductInfo },
              on: {
                productInfoDataFetchHandle: _vm.productInfoDataFetchHandle,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "Model",
          {
            attrs: {
              "is-show": _vm.isShowTrainingRecords,
              "dialog-status":
                _vm.$t("retailStoresInfo.form.model.trainRecord") +
                "__" +
                _vm.form.rtlFullName,
              "show-close": _vm.isShowTrainingRecords,
              "close-on-click-modal": _vm.isShowTrainingRecords,
              "is-hide-footer": !_vm.isShowTrainingRecordsHideFooter,
              width: "1200px",
              "auto-height": "",
            },
            on: {
              "update:isShow": function ($event) {
                _vm.isShowTrainingRecords = $event
              },
              "update:is-show": function ($event) {
                _vm.isShowTrainingRecords = $event
              },
            },
          },
          [
            _c("training", {
              ref: "training",
              on: {
                trainingRecordsDataFetchHandle:
                  _vm.trainingRecordsDataFetchHandle,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "Model",
          {
            attrs: {
              "is-show": _vm.isShowVisitRecord,
              "dialog-status":
                _vm.$t("retailStoresInfo.form.model.visitStoRecord") +
                "__" +
                _vm.form.rtlFullName,
              "auto-height": "",
              "show-close": _vm.isShowVisitRecord,
              "close-on-click-modal": _vm.isShowVisitRecord,
              "is-hide-footer": !_vm.isShowVisitRecordHideFooter,
              width: "1200px",
            },
            on: {
              "update:isShow": function ($event) {
                _vm.isShowVisitRecord = $event
              },
              "update:is-show": function ($event) {
                _vm.isShowVisitRecord = $event
              },
            },
          },
          [
            _c("visit-record", {
              ref: "visit",
              attrs: {
                "lookup-list": _vm.lookupList,
                "is-bai-lian": _vm.form.isBaiLian,
              },
              on: {
                visitRecordDataFetchHandle: _vm.visitRecordDataFetchHandle,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: { "append-to-body": true, visible: _vm.dialogVisible },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible = $event
              },
            },
          },
          [
            _c("MyImage", {
              staticStyle: { width: "100%", "z-index": "2024" },
              attrs: { src: _vm.dialogImageUrl },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }